document.addEventListener('DOMContentLoaded', function () {
    const hamburger = document.getElementById('hamburgerToggle');
    const mobileMenuDrawer = document.getElementById('mobileMenuDrawer');
    const menuOverlay = document.querySelector('.mobile-menu-overlay');
    const closeBtn = document.getElementById('mobileMenuClose');

    // Toggle menu on hamburger click
    if (hamburger) {
        hamburger.addEventListener('click', function (e) {
            e.stopPropagation();
            if (mobileMenuDrawer.classList.contains('active')) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });
    }

    // New Close Button listener
    if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            closeMobileMenu();
        });
    }

    // Close menu only when clicking the overlay (body area)
    if (menuOverlay) {
        menuOverlay.addEventListener('click', function () {
            closeMobileMenu();
        });
    }

    // Close menu on window resize (desktop)
    window.addEventListener('resize', function () {
        if (window.innerWidth > 991) {
            closeMobileMenu();
        }
    });

    // Handle keyboard escape key
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeMobileMenu();
        }
    });

    /**
     * Open mobile menu function
     */
    function openMobileMenu() {
        if (hamburger) hamburger.classList.add('active');
        if (mobileMenuDrawer) mobileMenuDrawer.classList.add('active');
        if (menuOverlay) menuOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    /**
     * Close mobile menu function
     */
    function closeMobileMenu() {
        if (hamburger) {
            hamburger.classList.remove('active');
        }
        if (mobileMenuDrawer) {
            mobileMenuDrawer.classList.remove('active');
        }
        if (menuOverlay) {
            menuOverlay.classList.remove('active');
        }
        document.body.style.overflow = '';
        
        // Reset submenus on close
        document.querySelectorAll('.mobile-nav-menu .menu-item-has-children').forEach(item => {
            item.classList.remove('open');
        });
    }

    /**
     * Submenu Toggle Logic
     */
    const menuItemsWithChildren = document.querySelectorAll('.mobile-nav-menu .menu-item-has-children > a');
    
    menuItemsWithChildren.forEach(link => {
        link.addEventListener('click', function (e) {
            const parentItem = this.parentElement;
            if (parentItem) {
                e.preventDefault();
                parentItem.classList.toggle('open');
            }
        });
    });
});
